"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.map = void 0;

/**
 * Iterate over an input list, calling `fn` for each element, return a new
 * array
 *
 * @param  {Function}  fn    The function
 * @param  {[]}        list  Array
 *
 * @return {Array}
 */
var map = function map() {
  for (var _len = arguments.length, fn = new Array(_len), _key = 0; _key < _len; _key++) {
    fn[_key] = arguments[_key];
  }

  return function (source) {
    var result = [];
    var sourceArray = Array.isArray(source) ? source : [source];

    for (var i = 0, valuesCount = sourceArray.length; i < valuesCount; i++) {
      var value = sourceArray[i]; // pipe functions through each value

      for (var j = 0, fnCount = fn.length; j < fnCount; j++) {
        value = fn[j].call(null, value, i, sourceArray);
      }

      result.push(value);
    }

    return result;
  };
};

exports.map = map;